import { render, staticRenderFns } from "./AnzanForm.vue?vue&type=template&id=0506f409&scoped=true&lang=pug&"
import script from "./AnzanForm.vue?vue&type=script&lang=js&"
export * from "./AnzanForm.vue?vue&type=script&lang=js&"
import style0 from "./AnzanForm.vue?vue&type=style&index=0&id=0506f409&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0506f409",
  null
  
)

export default component.exports